export const BASE_API_URL = __baseApiurl__;
